var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import merge from 'lodash-es/merge';
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { TranslateService } from "app/translate";
import { MailService } from "../mail.service";
import { ModalService } from "../../views/modal/base_modal.component";
import { MailerReport } from "./mailer.report";
import { PromptComponent } from "../../views/modal/prompt.component";
import { AlertComponent } from "../../views/modal/alert.component";
function getReportParams(emailKind, mailServises, fields, subscriptions, autologin) {
    return {
        reportName: 'Report Name',
        fields: fields.reduce(function (arr, field) {
            if (field.value) {
                arr.push(field.name);
            }
            return arr;
        }, []),
        mailServises: mailServises.reduce(function (arr, mail) {
            if (mail.value) {
                arr.push(mail.name);
            }
            return arr;
        }, []),
        email: emailKind,
        subscriptions: subscriptions.reduce(function (arr, subscription) {
            if (subscription.value) {
                arr.push(subscription.name);
            }
            return arr;
        }, []),
        autologin: autologin
    };
}
var MailerComponent = /** @class */ (function (_super) {
    __extends(MailerComponent, _super);
    function MailerComponent(eventsService, activatedRoute, filter, translate, modalService, router, route, mailService) {
        var _this = _super.call(this, eventsService, mailService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.router = router;
        _this.route = route;
        _this.mailService = mailService;
        _this.refGroupList = [];
        _this.emailKind = {
            userEmailIsExists: true,
            userEmailIsConfirm: true
        };
        _this.mailServises = [
            {
                name: 'gmail.com',
                value: true
            },
            {
                name: 'hotmail',
                value: true
            },
            {
                name: 'mail.ru',
                value: true
            },
            {
                name: 'rambler',
                value: true
            },
            {
                name: 'ya.ru',
                value: true
            },
            {
                name: 'yahoo',
                value: true
            },
            {
                name: 'other',
                value: true
            }
        ];
        _this.fields = [
            {
                name: '_id',
                disabled: true,
                value: true
            },
            {
                name: 'email',
                disabled: true,
                value: true
            },
            {
                name: 'domainUrl',
                disabled: true,
                value: true
            },
            {
                name: 'username',
                disabled: true,
                value: true
            },
            {
                name: 'unsubscribe_url',
                disabled: true,
                value: true
            },
            {
                name: 'created',
                disabled: false,
                value: false
            },
            {
                name: 'dateCreate',
                disabled: false,
                value: false
            },
            {
                name: 'datePublished',
                disabled: false,
                value: false
            },
            {
                name: 'location',
                disabled: false,
                value: false
            },
            {
                name: 'emailService',
                disabled: false,
                value: false
            },
            {
                name: 'referer',
                disabled: false,
                value: false
            },
            {
                name: 'autologin',
                disabled: false,
                value: false
            }
        ];
        _this.subscriptions = [
            {
                name: 'notifications',
                value: true
            },
            {
                name: 'remind',
                value: true
            },
            {
                name: 'discount',
                value: true
            },
            {
                name: 'news',
                value: true
            },
            {
                name: 'badge',
                value: true
            }
        ];
        _this.autologin = {
            expireAt: 14,
            url: 'pages/id/index/constructor',
        };
        _this.tariffs = ['premium', 'premiumplus', 'shop', 'pro'];
        _this.periods = ['24months', '12months', '6months', '3months', 'month'];
        _this.tariffVariants = [];
        _this._subUrl = '';
        _this.addFilterParams = {
            sitesFilter: 'with',
        };
        for (var _i = 0, _a = _this.tariffs; _i < _a.length; _i++) {
            var tariff = _a[_i];
            for (var _b = 0, _c = _this.periods; _b < _c.length; _b++) {
                var period = _c[_b];
                _this.tariffVariants.push("/" + tariff + "?period=" + period);
            }
        }
        _this.isLoad = false;
        return _this;
    }
    Object.defineProperty(MailerComponent.prototype, "subUrl", {
        get: function () {
            return (this.autologin.url === 'dashBoard/billing/tariffs' ? this._subUrl : '');
        },
        set: function (value) {
            this._subUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    MailerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, _super.prototype.ngOnInit.call(this)];
                    case 1:
                        _b.sent();
                        me = this;
                        _a = me;
                        return [4 /*yield*/, me.filter.getRefGroupFilterList()];
                    case 2:
                        _a.refGroupList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerComponent.prototype.showReportList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, w, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        w = me.modalService.open(MailerReport, {
                            title: 'Список вызгрузок',
                            reports: []
                        }, { size: 'hg' });
                        w.componentInstance.isLoading = true;
                        _a = w.componentInstance;
                        return [4 /*yield*/, me.mailService.mailer.get({}, 'report').toPromise()];
                    case 1:
                        _a.reports = _b.sent();
                        w.componentInstance.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerComponent.prototype.addNewReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, filterParams, report, modalRef, reportName, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        filterParams = me.filter.getCopyFilterParams();
                        report = getReportParams(this.emailKind, this.mailServises, this.fields, this.subscriptions, merge({}, this.autologin, { url: "" + this.autologin.url + this.subUrl }));
                        if (report.mailServises.length === 0) {
                            this.modalService.open(AlertComponent, {
                                title: 'Внимание!',
                                message: 'Выберите хоть один из пунктов "Почтовый сервис получателя"'
                            });
                            return [2 /*return*/];
                        }
                        if (report.subscriptions.length === 0) {
                            this.modalService.open(AlertComponent, {
                                title: 'Внимание!',
                                message: 'Выберите хоть один из пунктов "Категория"'
                            });
                            return [2 /*return*/];
                        }
                        if (report.fields.length > 9) {
                            this.modalService.open(AlertComponent, {
                                title: 'Внимание!',
                                message: 'Кол-во dop-полей в "Парметры выборки" должно быть не больше 3-х'
                            });
                            return [2 /*return*/];
                        }
                        modalRef = me.modalService.open(PromptComponent, {
                            title: 'Название выборки',
                            question: 'Имя выборки должно содержать только латиницу, цифры и _'
                        });
                        reportName = '';
                        modalRef.componentInstance.onChange.subscribe(function (value) {
                            modalRef.componentInstance.errors = [];
                            if (value.match(/^[a-z0-9-_]{4,}$/i)) {
                                reportName = value;
                                return;
                            }
                            modalRef.componentInstance.errors.push('Имя должно состоять из латинских букв и цифр (длина больше 4-х символов)');
                        });
                        return [4 /*yield*/, modalRef.result];
                    case 1:
                        r = _a.sent();
                        // TODO Убрать явное использование modalRef.result, заменив на более лучшую версию modalRef.$o
                        // Мы должны отличать закрытие формы (по крестику и Close) и применение (Submit)
                        if (r === 'cancel') {
                            return [2 /*return*/];
                        }
                        if (!reportName) {
                            return [2 /*return*/];
                        }
                        report.reportName = reportName;
                        filterParams.report = report;
                        me.mailService.mailer
                            .post(filterParams, 'report')
                            .subscribe(function (r) { return console.log('Ok', r); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerComponent.prototype.clearFilter = function () {
        var me = this, url = me.router.url.split('?')[0];
        me.router.navigate([url], { relativeTo: me.route, queryParams: {} });
    };
    return MailerComponent;
}(BaseComponent));
export { MailerComponent };
